import type { AnnouncementType } from '../../types/announcement'

interface Props {
  type: AnnouncementType
}

// Small label chip. Ack-required types read as higher-stakes (amber); plain
// informational types are neutral.
const AnnouncementTypeBadge = ({ type }: Props) => {
  const styles = type.requires_ack
    ? 'bg-amber-100 text-amber-800 border-amber-200'
    : 'bg-secondary-100 text-secondary-700 border-secondary-200'
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${styles}`}>
      {type.label}
    </span>
  )
}

export default AnnouncementTypeBadge
